<template>
  <div>
    <!-- 查看分班进度按钮 -->
    <div class="divide-status">
      <Icon type="ios-list-box" size="24" color="#488ffa"></Icon>
      <span class="divide-status-text" @click="handleOpenDivideStatus"
        >分班进度</span
      >
      <Icon
        v-if="showStatusLoading"
        class="loading-icon"
        type="ios-loading"
        size="24"
        color="#488ffa"
      ></Icon>
    </div>
    <!-- 分班结果任务进度列表抽屉 -->
    <Drawer
      v-model="divideResultShow"
      title="提示"
      width="60"
      placement="right"
      @on-visible-change="dealClose($event, 'result')"
    >
      <div class="result-block">
        <Icon
          type="ios-checkmark-circle"
          size="100"
          color="rgb(90, 196, 45)"
        ></Icon>
        <div class="success-title">
          分班操作发起成功，请耐心等待系统处理结果！
        </div>
        <div class="success-tips">可关闭当前页面，继续操作其他分班。</div>
      </div>
      <Table
        :loading="tableLoading"
        :columns="resultStatusColumn"
        :data="statusList"
        border
        max-height="600"
      >
        <template slot="procSts" slot-scope="{ row }">
          <span :class="'status-' + row.procSts">
            {{ procStsObj[row.procSts]
            }}{{ row.procSts === 3 ? `(${row.msg})` : '' }}
          </span>
          <Icon
            v-if="row.procSts === 0 || row.procSts === 2"
            class="loading-icon"
            type="ios-loading"
            size="16"
            color="#488ffa"
          ></Icon>
        </template>
      </Table>
    </Drawer>
    <!-- 分班进度列表抽屉 -->
    <Drawer
      v-model="isShowDrawer"
      title="分班进度"
      width="60"
      placement="right"
      @on-visible-change="dealClose"
    >
      <Alert>
        <div>①展示该学期下通过智能分班产生的分班记录及分班进度</div>
        <div style="margin-top: 8px">
          ②一个课程商品同时<span style="color: red; font-weight: bold"
            >有且仅允许存在一个分班中进度</span
          >任务。
        </div>
      </Alert>
      <Table
        :loading="tableLoading"
        :columns="statusColumn"
        :data="statusList"
        border
      >
        <template slot="procSts" slot-scope="{ row }">
          <span :class="'status-' + row.procSts">
            {{ procStsObj[row.procSts]
            }}{{ row.procSts === 3 ? `(${row.msg})` : '' }}
          </span>
          <Icon
            v-if="row.procSts === 0 || row.procSts === 2"
            class="loading-icon"
            type="ios-loading"
            size="16"
            color="#488ffa"
          ></Icon>
        </template>
      </Table>
      <div class="paging">
        <span class="total">10条/页</span>
        <Page
          :current="pageNo"
          :total="total"
          :page-size="pageSize"
          show-total
          show-elevator
          @on-change="onPageChange"
        ></Page>
      </div>
    </Drawer>
  </div>
</template>
<script>
import axios from 'axios';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  props: {
    step: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isShowDrawer: false, // 是否展示抽屉
      statusColumn: [
        {
          title: '操作人',
          key: 'operatorName',
          minWidth: 140
        },
        {
          title: '课程商品名称',
          key: 'productName',
          minWidth: 220
        },
        {
          title: '处理分班数',
          key: 'divideNum',
          minWidth: 80
        },
        {
          title: '分班开始时间',
          key: 'createTime',
          minWidth: 180
        },
        {
          title: '分班完成时间',
          key: 'finTime',
          minWidth: 180
        },
        {
          title: '状态',
          slot: 'procSts',
          minWidth: 180
        }
      ], // 进度列表表头
      statusList: [], // 进度列表数据
      schoolId: '', // 查询哪个学校的数据
      yearCode: '', // 查询哪个学期
      termCode: '', // 查询哪个学期
      total: 0, // 进度列表一共有多少条数据
      pageNo: 1, // 进度列表第几页
      pageSize: 10, // 进度列表一页几条数据
      source: null, // 可以控制是否要中断获取列表实时状态的api
      loadingTotal: 0, // 在执行中的任务有多少条数据
      loadingTaskList: [], // 执行中的任务列表
      loadingSource: null, // 可以控制是否要中断获取列表实时状态的api
      showStatusLoading: false, // 是否展示分班中的loading
      procStsObj: {
        0: '分班中',
        1: '已完成',
        2: '分班中',
        3: '分班失败'
      }, // 0-待执行 1-完成 2-进行中 3-失败
      divideResultShow: false,
      resultStatusColumn: [
        {
          title: '课程商品名称',
          key: 'productName',
          minWidth: 220
        },
        {
          title: '处理分班数',
          key: 'divideNum',
          minWidth: 80
        },
        {
          title: '分班开始时间',
          key: 'createTime',
          minWidth: 180
        },
        {
          title: '分班完成时间',
          key: 'finTime',
          minWidth: 180
        },
        {
          title: '状态',
          slot: 'procSts',
          minWidth: 180
        }
      ],
      tableLoading: false
    };
  },
  computed: {
    // 在执行中的任务的id
    batchIds() {
      const list = this.statusList.filter(item => {
        return item.procSts === 0 || item.procSts === 2;
      });
      return list.map(item => {
        return item.batchId;
      });
    }
  },
  watch: {
    step(newVal) {
      if (newVal === 2) {
        this.handleCancel();
        this.cancelLoading();
      } else {
        this.getLoadingTask();
      }
    }
  },
  mounted() {
    this.$eventHub.$on('divideTaskStart', upBatchId => {
      // this.backStep(data);
      this.getDivideTaskStatus(upBatchId);
    });
  },
  destroyed() {
    this.handleCancel();
    this.cancelLoading();
    this.$eventHub.$off('divideTaskStart');
  },
  methods: {
    // 通过父级任务id获取该任务完成情况
    async getDivideTaskStatus(upBatchId, pageSize) {
      if (!pageSize) {
        this.divideResultShow = true;
      }
      this.tableLoading = true;
      try {
        const res = await courseSchedulCenter.getTaskStatusListApi({
          upBatchId,
          busiCode: 1, //  业务编码 1-智能分班
          exeFlag: 1,
          pageSize: pageSize || 10
        });
        if (res.status === 200) {
          const branchIds = [];
          if (pageSize !== undefined) {
            this.tableLoading = false;
            this.statusList = res.message.list.map(item => {
              if (item.batchProcData.procSts === 0 || item.batchProcData.procSts === 2) {
                branchIds.push(item.batchProcData.batchId);
              }
              return {
                ...item.batchProcData,
                ...item.properties,
                msg: item.batchProcData.procSts === 3 ? item.batchProcData.lineData3 : ''
              };
            });
          }
          res.message.total > 10 && !pageSize ? this.getDivideTaskStatus(upBatchId, res.message.total) : branchIds.length > 0 ? this.getTaskProgressList(1, branchIds, 'result') : this.closeResultModal();
        } else {
          this.tableLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.tableLoading = false;
      }
    },
    closeResultModal() {
      this.$Message.success('智能分班任务完成！');
      this.divideResultShow = false;
    },
    // 初始化执行中的任务
    initLoadingTag({ schoolId, yearCode, termCode }) {
      this.schoolId = schoolId;
      this.yearCode = yearCode;
      this.termCode = termCode;
      this.getLoadingTask();
    },
    // 获取在执行中的任务
    async getLoadingTask(pageSize) {
      const params = {
        busiCode: 1, //  业务编码 1-智能分班
        schoolIdList: [this.schoolId], // 学校id
        yearCode: this.yearCode,
        termCode: this.termCode,
        pageSize: pageSize || 10,
        pageNo: 1,
        exeFlag: 1,
        procStsList: [0, 2] // 0-待执行 1-完成 2-进行中 3-失败
      };
      const res = await courseSchedulCenter.getTaskIngListApi(params);
      if (res.status === 200) {
        this.loadingTotal = +res.message.total;
        const branchIds = res.message.map(item => {
          return item.batchProcData.batchId;
        });
        this.loadingTotal > 10 && !pageSize ? this.getLoadingTask(this.loadingTotal) : this.getLoadingTaskProgressList(branchIds);
      }
    },
    // 获取成功的任务
    async getLoadingTaskProgressList(branchIds, showTips = false) {
      if (branchIds.length === 0) {
        this.showStatusLoading = false;
        return;
      }
      const params = {
        batchIds: branchIds, // 任务id
        returnThreshold: 100 // 默认全部完成返回，百分比
      };
      this.loadingSource = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.loadingSource.token);
      if (res.status === 200) {
        const loadingIdsArray = res.message.filter(item => {
          return item.prcSts === 2 || item.prcSts === 0;
        });
        const loadingIds = loadingIdsArray.map(item => {
          return item.batchId;
        });
        this.showStatusLoading = loadingIds.length > 0;
        this.showStatusLoading ? this.getLoadingTaskProgressList(loadingIds, showTips) : '';
      }
    },
    // 点击打开分班进度列表抽屉
    handleOpenDivideStatus() {
      this.openDrawer();
    },
    openDrawer() {
      this.isShowDrawer = true;
      this.pageNo = 1;
      this.cancelLoading();
      this.getStatusList();
    },
    // 获取分班进度表
    async getStatusList() {
      const params = {
        busiCode: 1, //  业务编码 1-智能分班
        schoolIdList: [this.schoolId], // 学校id
        yearCode: this.yearCode,
        termCode: this.termCode,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        exeFlag: 1
      };
      try {
        this.tableLoading = true;
        const res = await courseSchedulCenter.getTaskStatusListApi(params);
        if (res.status === 200) {
          this.total = +res.message.total;
          const branchIds = [];
          this.statusList = res.message.list.map(item => {
            branchIds.push(item.batchProcData.batchId);
            return {
              ...item.batchProcData,
              ...item.properties
            };
          });
          if (branchIds.length > 0) {
            this.getTaskProgressList(1, branchIds);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.tableLoading = false;
      }
    },
    // 获取分班进度
    async getTaskProgressList(type, batchIds, tag = '') {
      const params = {
        batchIds: type ? batchIds : this.batchIds, // 任务id
        returnThreshold: 100 // 默认全部完成返回，百分比
      };
      this.source = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.source.token);
      this.source = null;
      if (res.status === 200) {
        const obj = {};
        res.message.forEach(item => {
          item.procSts = item.prcSts;
          item.prcSts === 0 || item.prcSts === 2 ? item.finTime = '' : '';
          obj[item.batchId] = item;
        });
        this.statusList = this.statusList.map(item => {
          if (obj[item.batchId]) {
            return { ...item, ...obj[item.batchId] };
          } else {
            return { ...item };
          }
        });
        this.batchIds.length > 0 ? this.getTaskProgressList(tag) : tag ? this.closeResultModal() : '';
      }
    },
    dealClose(status, type) {
      if (!status) {
        this.handleCancel();
        this.getLoadingTask();
        this.getLoadingTask();
        type === 'result' ? this.$eventHub.$emit('backStep', {
          type: 'refresh'
        }) : '';
      }
    },
    handleClose() {
      this.handleCancel();
      this.getLoadingTask();
    },
    // 导出-进度条
    handleCancel() {
      this.source ? this.source.cancel('取消请求') : '';
    },
    cancelLoading() {
      this.loadingSource ? this.loadingSource.cancel('取消请求') : '';
    },
    onPageChange(pageNo) {
      this.pageNo = pageNo;
      this.handleCancel();
      this.getStatusList();
    }
  }
};
</script>
<style lang="scss" scoped>
.divide-status {
  // position: absolute;
  // left: 0;
  // top: 50%;
  // transform: translateY(-50%);
  padding-top: 16px;
  display: flex;
  align-items: center;
  .divide-status-text {
    margin: 0 8px;
    font-size: 16px;
    color: #488ffa;
    cursor: pointer;
  }
}
.loading-icon {
  animation: circletrun 1s linear infinite;
}
@keyframes circletrun {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.status-1 {
  color: #444;
}
.status-0 {
  color: #488ffa;
}
.status-2 {
  color: #488ffa;
}
.status-3 {
  color: rgb(212, 0, 37);
}
.result-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  .success-title {
    font-size: 24px;
    font-weight: bold;
    margin-top: 8px;
  }
  .success-tips {
    font-size: 16px;
    color: #333;
    margin-top: 8px;
  }
}
.paging {
  display: flex;
  align-items: center;
  .total {
    margin-right: 10px;
  }
}
</style>
